module.exports = __webpack_public_path__ + "static/media/rightcom-logo.f4f6de74.svg";